import { GET, POST, PUT } from 'js/constants/requestMethods';
import { CALL_PRIVATE_API } from 'js/middleware/api';
import { Dispatch } from 'redux';
import * as actionTypes from '../../constants/actionTypes';
import genAiConfigs from 'js/schemas/genAiConfigs';

export const loadGenAiConfigs = () => (dispatch: Dispatch<any>) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_GEN_AI_CONFIGS_REQUEST,
        actionTypes.GET_GEN_AI_CONFIGS_SUCCESS,
        actionTypes.GET_GEN_AI_CONFIGS_FAILURE,
      ],
      endpoint: '/gen_ai_integration_configs',
      schema: [genAiConfigs],
      requestMethod: GET,
    },
  });
};

export const addGenAiConfig = (payload) => (dispatch: Dispatch<any>) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.ADD_GEN_AI_CONFIG_REQUEST,
        actionTypes.ADD_GEN_AI_CONFIG_SUCCESS,
        actionTypes.ADD_GEN_AI_CONFIG_FAILURE,
      ],
      endpoint: '/gen_ai_integration_configs',
      schema: genAiConfigs,
      requestMethod: POST,
      payload,
    },
  });
};

export const updateGenAiConfig = (id, payload) => (dispatch: Dispatch<any>) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.UPDATE_GEN_AI_CONFIG_REQUEST,
        actionTypes.UPDATE_GEN_AI_CONFIG_SUCCESS,
        actionTypes.UPDATE_GEN_AI_CONFIG_FAILURE,
      ],
      endpoint: `/gen_ai_integration_configs/${id}`,
      schema: genAiConfigs,
      requestMethod: PUT,
      payload,
    },
  });
};
